(function() {
    'use strict';

    angular
        .module('atheer')
        .factory('notificationInterceptor', notificationInterceptor);

    /* @ngInject */
    function notificationInterceptor ($q, AlertService) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            var alertKey = response.headers('X-atheer-alert');
            if (angular.isString(alertKey)) {
                AlertService.success(alertKey, { param : response.headers('X-atheer-params')});
            }
            return response;
        }
    }
})();
